var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_c('router-link',{attrs:{"to":"/games"}},[_vm._v("Games")]),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }